import React, { useCallback, useContext, useState } from 'react';
import { prop } from 'ramda';
import { componentService } from 'js/services/component.service';
import { PortletContext, usePortletTranslations, withPortlet } from 'js/components/system/Portlet';
import { Loader } from 'js/components/common/Loader';
import { Button } from 'js/components/common/Button';
import { useAppSelector } from 'js/store/hooks';

import { sendVerificationEmail } from './actions';
import { SEND_VERIFICATION_EMAIL } from './constants';

import style from './index.scss';

const useOnClick = (changeScreen) => {
    const casinoName = useAppSelector(prop('casinoName'));
    const template = prop('emailTemplateName', useContext(PortletContext));

    return useCallback(async () => {
        changeScreen('loading');

        try {
            await sendVerificationEmail({ template, casinoName });
            changeScreen('success');
        } catch (err) {
            changeScreen('error');
        }
    }, [changeScreen, template, casinoName]);
};

export const SendVerificationEmailBare = () => {
    const t = usePortletTranslations();
    const [activeScreen, changeScreen] = useState();
    const onClick = useOnClick(changeScreen);

    return activeScreen === 'loading'
        ? <Loader />
        : <div className={style.container}>
            {
                activeScreen
                    ? t(activeScreen)
                    : <Button type="button"
                        size="medium"
                        onClick={onClick}
                        className={style.button}>
                        {t('submit')}
                    </Button>
            }
        </div>;
};

export const SendVerificationEmail = withPortlet({ forLoggedIn: true })(SendVerificationEmailBare);

componentService.registerWebContentComponents({ SendVerificationEmail });
componentService.registerPageComponents({ [SEND_VERIFICATION_EMAIL]: SendVerificationEmail });
